/**
 * One-line nav glossary (design-review #15).
 */
export const NAV_GLOSSARY = {
    'timesheets': 'Log, submit, and approve weekly hours.',
    'expenses': 'Capture receipts and expense reports.',
    'helpdesk': 'Internal support tickets and knowledge base.',
    'gps': 'Field location check-in and geofencing.',
    'reports': 'Operational and financial report exports.',
    'executive-dashboard': 'Strategic KPIs, portfolio health, and revenue triad.',
    'project-operations': 'Projects, tasks, staffing, and delivery oversight.',
    'my-workspace': 'Your assigned tasks and time entry shortcuts.',
    'overview-dashboard': 'Cross-functional summary for managers.',
    'financial-management': 'AR, WIP, margins, and billing operations.',
    'analytics-dashboard': 'BI trends, predictive analytics, and custom reports.',
    'ai-intelligence': 'Natural-language queries over PSA data.',
    'observability': 'System health, logs, and integration monitors.',
    'resource-planning': 'Capacity, utilization, and allocation planning.',
    'pm-integration': 'Connect external project management tools.',
    'crm-integration': 'Sync clients and opportunities from CRM.',
    'communication': 'Email and messaging platform hooks.',
    'document-control': 'Controlled documents and version history.',
    'gantt-chart': 'Schedule timelines and dependencies.',
    'revenue-recognition': 'ASC 606 revenue recognition workflows.',
    'invoice-management': 'Client invoicing and billing runs.',
    'quickbooks': 'QuickBooks accounting sync.',
    'xero': 'Xero accounting sync.',
    'admin': 'Tenant configuration and system settings.',
    'users': 'User accounts, roles, and permissions.',
    'tenant-management': 'Multi-tenant administration.',
    'theme-showcase': 'Design tokens and component preview.',
    'help-center': 'Comprehensive guide with screenshots for every major workflow.',
};
